"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DivisibleStack = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const DivisibleStack = (props) => {
    const { children, divider, wrapper } = props;
    let content;
    if (divider) {
        content = react_1.Children.toArray(children)
            .filter(Boolean)
            .flatMap((child, index) => {
            if (index === 0) {
                return [child];
            }
            return [divider && (0, jsx_runtime_1.jsx)("div", { className: divider }, `divider-${index}`), child];
        });
    }
    else {
        content = children;
    }
    if (wrapper) {
        return (0, jsx_runtime_1.jsx)("div", { className: wrapper, children: content });
    }
    else {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: content });
    }
};
exports.DivisibleStack = DivisibleStack;
